export const ShareButtonsScripts: React.FC = () => {
  return (
    <>
      <script async src="https://b.st-hatena.com/js/bookmark_button.js" />
      <script async src="https://platform.twitter.com/widgets.js" />
      <script
        async
        crossOrigin="anonymous"
        src="https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v10.0"
        nonce="jX8miYcO"
      />
    </>
  );
};
